import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=14e4709a&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"
import style0 from "./Price.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports